(() => {
  'use strict';
  const sizeParam = 'filter.v.option.taglia';
  const normalizedSizeParam = 'filter.v.m.fango.taglia_filtro';
  const genderParam = 'filter.p.m.atelier.genere';
  let genderInputCounter = 0;
  function sizeLabel(raw) {
    const text = raw.trim().replace(/ ([12])\/([23])$/, (match, numerator, denominator) => ({'1/2':'½','1/3':'⅓','2/3':'⅔'}[numerator+'/'+denominator] || match));
    if (/^(UNI|UNICA|TU|T\.U\.|OS|O\/S|ONE SIZE|TAGLIA UNICA)$/i.test(text)) return 'Taglia unica';
    if (/^\d+[.,]5$/.test(text)) return text.replace(/[.,]5$/, '½');
    return text;
  }
  function groupFor(label) {
    if (label.startsWith('Brand ')) return label.slice(6, label.lastIndexOf(' · ')) + ' · taglie brand';
    if (label.startsWith('Scarpe EU ')) return 'Scarpe · EU';
    if (label.startsWith('Abbigliamento IT ')) return 'Abbigliamento · IT';
    if (label.startsWith('Jeans W ')) return 'Jeans · W';
    if (label.startsWith('Alfabetica ')) return 'Taglie alfabetiche';
    if (label === 'Taglia unica') return 'Taglia unica';
    if (/^(XXS|XS|S|M|L|XL|XXL|XXXL)$/i.test(label)) return 'Taglie alfabetiche';
    if (/^(XXS|XS|S|M|L|XL|XXL)[\/-](XXS|XS|S|M|L|XL|XXL)$/i.test(label) || /^\d+[\/-]\d+$/.test(label)) return 'Taglie combinate';
    if (/^\d+(?:½|[.,]\d+| [12]\/[23])?$/.test(label)) return 'Taglie numeriche';
    return 'Altri formati';
  }
  const letterOrder = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];
  const displaySize = label => label.replace(/^(Scarpe EU |Abbigliamento IT |Jeans W |Alfabetica |Brand .+ · )/, '');
  function compareSize(a, b) {
    a = displaySize(a); b = displaySize(b);
    const ai = letterOrder.indexOf(a), bi = letterOrder.indexOf(b);
    if (ai >= 0 && bi >= 0) return ai - bi;
    const number = value => Number(value.replace('½', '.5').replace('⅓', '.333').replace('⅔', '.667').replace(',', '.').replace(/ ([12])\/([23])$/, (_, n, d) => '.' + String(Math.round(Number(n) / Number(d) * 1000)).padStart(3, '0')));
    const an = number(a), bn = number(b);
    return Number.isFinite(an) && Number.isFinite(bn) ? an - bn : a.localeCompare(b, 'it', {numeric:true});
  }
  function buildSizes(component) {
    if (component.dataset.fangoBuilt) return;
    const list = component.querySelector('ul.facets__inputs-list');
    if (!list) return;
    component.dataset.fangoBuilt = 'true';
    const buckets = new Map();
    for (const input of list.querySelectorAll('input[type="checkbox"]')) {
      if (input.name !== sizeParam && input.name !== normalizedSizeParam) continue;
      const li = input.closest('li');
      if (!li) continue;
      li.classList.remove('hidden', 'mobile:hidden');
      const label = sizeLabel(input.dataset.label || input.value);
      if (!buckets.has(label)) buckets.set(label, []);
      buckets.get(label).push({input, li});
    }
    const grouped = document.createElement('div');
    grouped.className = 'fango-size-groups';
    for (const groupName of ['Scarpe · EU','Abbigliamento · IT','Jeans · W','Taglie alfabetiche','Taglie numeriche','Taglie combinate','Taglia unica','Altri formati', ...new Set([...buckets.keys()].filter(label => label.startsWith('Brand ')).map(groupFor))]) {
      const entries = [...buckets].filter(([label]) => groupFor(label) === groupName).sort(([a],[b]) => compareSize(a,b));
      if (!entries.length) continue;
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = groupName;
      const ul = document.createElement('ul');
      ul.className = 'fango-size-options';
      for (const [label, items] of entries) {
        if (items.length === 1 && displaySize(label) === (items[0].input.dataset.label || items[0].input.value)) {
          ul.append(items[0].li);
          continue;
        }
        const li = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.role = 'checkbox';
        button.setAttribute('aria-checked', String(items.some(x=>x.input.checked)));
        button.disabled = items.every(x=>x.input.disabled);
        button.className = 'fango-size-alias';
        button.textContent = displaySize(label);
        button.addEventListener('click', () => {
          const checked = button.getAttribute('aria-checked') !== 'true';
          items.forEach(({input})=> { if (!input.disabled) input.checked = checked; });
          button.setAttribute('aria-checked', String(checked));
          component.dispatchEvent(new Event('change', {bubbles:true}));
        });
        li.append(button);
        items.forEach(({li:original}) => {original.hidden=true;ul.append(original);});
        ul.append(li);
      }
      fieldset.append(legend, ul);grouped.append(fieldset);
    }
    list.before(grouped);
    list.hidden = true;
    const note = document.createElement('p');
    note.className = 'fango-size-format-note';
    note.textContent = component.querySelector('input[name="'+normalizedSizeParam+'"]') ? 'Equivalenze secondo la guida del brand. Nei gruppi con il nome del brand le misure sono quelle originali; in scheda e nel carrello restano sempre le taglie del prodotto.' : 'Taglie originali del brand. Le scale EU, US e UK non sono equivalenti.';
    grouped.after(note);
    component.querySelector('.show-more__button')?.setAttribute('hidden','');
  }
  function buildGender(component) {
    if (component.dataset.fangoBuilt) return;
    component.dataset.fangoBuilt = 'true';
    const rawInputs = [...component.querySelectorAll('input[type="checkbox"]')];
    const unisex = rawInputs.find(input=>input.value === 'Unisex');
    const list = component.querySelector('ul.facets__inputs-list');
    if (unisex && !unisex.disabled && list) {
      for (const gender of ['Donna','Uomo']) {
        if (rawInputs.some(input=>input.value === gender)) continue;
        const li = document.createElement('li');
        li.className = 'facets__inputs-list-item';
        const wrapper = document.createElement('div');
        wrapper.className = 'checkbox';
        const input = document.createElement('input');
        input.type = 'checkbox';input.name = genderParam;input.value = gender;
        input.id = 'fango-gender-' + (++genderInputCounter);
        input.className = 'checkbox__input';input.dataset.label = gender;
        input.setAttribute('ref','facetInputs[]');
        input.checked = new URL(location.href).searchParams.getAll(genderParam).includes(gender);
        const label = document.createElement('label');
        label.className = 'checkbox__label';label.htmlFor = input.id;
        const text = document.createElement('span');
        text.className = 'checkbox__label-text';text.textContent = gender;
        label.append(text);wrapper.append(input,label);li.append(wrapper);list.append(li);
      }
    }
    for (const input of component.querySelectorAll('input[type="checkbox"]')) {
      if (input.value === 'Unisex') input.closest('li').hidden = true;
      if (input.value === 'Uomo' || input.value === 'Donna') {
        input.disabled = false;
        input.closest('li')?.classList.remove('facets__inputs-list-item--disabled');
      }
    }
    const note = document.createElement('p');
    note.className = 'fango-size-format-note';
    note.textContent = 'Gli articoli unisex sono inclusi sia in Donna sia in Uomo.';
    component.append(note);
  }
  const filterSelector = '[data-fango-size-filter], [data-fango-gender-filter], [data-fango-types]';
  function refresh(root = document) {
    const components = root.matches?.(filterSelector) ? [root] : [];
    components.push(...root.querySelectorAll(filterSelector));
    for (const component of components) {
      if (component.matches('[data-fango-size-filter]')) buildSizes(component);
      else if (component.matches('[data-fango-gender-filter]')) buildGender(component);
      else {
        const url = new URL(location.href);
        url.searchParams.delete('page');
        url.searchParams.delete('filter.p.product_type');
        for (const value of JSON.parse(component.dataset.fangoTypes)) url.searchParams.append('filter.p.product_type', value);
        component.href = url.pathname + url.search;
      }
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-fango-types]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const form = document.querySelector('facets-form-component');
    if (!form || typeof form.updateFiltersByURL !== 'function') return;
    event.preventDefault();
    form.updateFiltersByURL(link.href);
  });
  const observer = new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) {
      // Section morphing may keep the filter element and replace only its children.
      const component = record.target instanceof Element ? record.target.closest('[data-fango-size-filter], [data-fango-gender-filter]') : null;
      if (component && !component.dataset.fangoBuilt) roots.add(component);
      for (const node of record.addedNodes) {
        if (!(node instanceof Element) || node.closest('.fango-size-groups')) continue;
        if (node.matches(filterSelector) || node.querySelector(filterSelector)) roots.add(node);
      }
    }
    for (const root of roots) if (![...roots].some(other => other !== root && other.contains(root))) refresh(root);
  });
  const start = () => {
    if (!document.querySelector(filterSelector)) return;
    refresh();
    observer.observe(document.querySelector('main') || document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
